export default function ContactsListSkeleton() {
  // TODO: Skeleton
}
